const styles = {
  fieldsWrapper: { display: 'flex', gap: 2 },
  selectField: { minWidth: 280 },
  datePickerField: { minWidth: 200 },
}

export default styles
